import { render } from "./PatientInsurance.vue?vue&type=template&id=6c0849f1&ts=true"
import script from "./PatientInsurance.vue?vue&type=script&lang=ts"
export * from "./PatientInsurance.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__